import { Stack } from '@fluentui/react';

import type { S3Object } from '../../../../drive/types';
import { DirectoryItem } from './DirectoryItem';

interface DirectoryListProps {
  objects: S3Object[];
  currentPath: string;
  onNavigate: (path: string) => void;
  permissionError?: boolean;
}

const EmptyState = ({ message }: { message: string }) => (
  <div style={{ padding: '16px', textAlign: 'center', color: '#605e5c' }}>{message}</div>
);

export const DirectoryList = ({ objects, currentPath, onNavigate, permissionError }: DirectoryListProps) => {
  if (permissionError) {
    return <EmptyState message="You don't have writer permission in this workspace" />;
  }

  if (objects.length === 0) {
    return <EmptyState message="No directories found" />;
  }

  return (
    <Stack>
      {objects.map((item) => (
        <DirectoryItem key={item.Key || 'parent'} item={item} currentPath={currentPath} onNavigate={onNavigate} />
      ))}
    </Stack>
  );
};
